import * as R from 'ramda'
import { RSAA } from 'redux-api-middleware'
import {
  getApiPath,
  mapObjectKeys,
  makeQueryParams,
} from 'sidecar-utility-library'

import { initialState, types } from 'store/Doctor'

export const fetchSuggestions = query => ({
  [RSAA]: {
    endpoint: ({ SearchFilters = {} }) => {
      const searchFilters = SearchFilters?.filters

      const queryParams = R.pipe(
        mapObjectKeys({
          query: query || R.prop('query'),
          city: R.path(['searchLocation', 'city']),
          state: R.path(['searchLocation', 'state']),
          lat: R.path(['searchLocation', 'lat']),
          lon: R.path(['searchLocation', 'lon']),
          radius: R.path(['searchLocation', 'radius']),
        }),
        R.pick(['query', 'city', 'state', 'lat', 'lon', 'radius']),
        makeQueryParams,
      )(searchFilters)

      return getApiPath('doc', `doctors/suggest${queryParams}`, 'v2')
    },
    method: 'GET',
    types: [
      types.FETCH_SUGGESTIONS_REQUEST,
      types.FETCH_SUGGESTIONS_SUCCESS,
      types.FETCH_SUGGESTIONS_ERROR,
    ],
  },
})

export default (state = initialState, { type, payload = {} } = {}) => {
  switch (type) {
    case types.FETCH_SUGGESTIONS_REQUEST: {
      return {
        ...state,
        suggestions: {
          ...state.suggestions,
          busy: true,
          error: null,
        },
      }
    }
    case types.FETCH_SUGGESTIONS_SUCCESS: {
      const { content = [] } = payload
      return {
        ...state,
        suggestions: {
          ...state.suggestions,
          busy: false,
          entities: content,
        },
      }
    }
    case types.FETCH_SUGGESTIONS_ERROR: {
      return {
        ...state,
        suggestions: {
          ...state.suggestions,
          busy: false,
          error: payload.response.message,
        },
      }
    }

    // ----------

    default:
      return state
  }
}
